import { useAuthStore } from '@/stores/auth'
import { useSignupStore } from '@/stores/signup'
import type { NavigationGuardNext, RouteLocationNormalizedGeneric } from 'vue-router'
import type { RouteMetaCustom } from '../types'
import { hardReloadOnStoreError } from '@/utils/storeUtils'
import createLogger from '@/utils/logger'

const logger = createLogger('router/guards/waitForSignup.ts')

export async function waitForSignup(
  to: RouteLocationNormalizedGeneric,
  _from: RouteLocationNormalizedGeneric,
  next: NavigationGuardNext,
) {
  const routeIsSignup = to.matched.some((record) => (record.meta as RouteMetaCustom).isSignup)
  const authStore = useAuthStore()

  if (routeIsSignup && authStore.isCustomer) {
    const signupStore = useSignupStore()

    try {
      const loadingCompleted = await signupStore.untilLoadingIsDone()
      if (!loadingCompleted) {
        logger.error('Error waiting for signup state, hard reloading')
        await hardReloadOnStoreError()
        return
      }
    } catch (_error) {
      logger.error('Error waiting for signup state, signing out and redirecting to login')
      await authStore.signOut({
        redirectToLogin: true,
        errorMessage:
          'An error occurred while loading the signup state. Please try to login again.',
        hardReloadToLogin: true,
      })
      return
    }
  }
  next()
}
